module.exports = __webpack_public_path__ + "static/media/bolinha_status_exportacao.55190269.svg";